import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.286 1.088a2 2 0 0 0-.572 0 2.785 2.785 0 0 0-.584.17l-.043.016-5.492 2.06c-.618.23-1.16.433-1.578.801a3 3 0 0 0-.82 1.184c-.199.52-.198 1.1-.197 1.759V12c0 2.826 1.537 5.183 3.2 6.914 1.672 1.743 3.586 2.974 4.598 3.564l.041.024c.185.109.425.25.742.318.26.055.579.055.838 0 .317-.068.557-.209.742-.317l.04-.024c1.013-.591 2.927-1.822 4.6-3.565C19.463 17.184 21 14.826 21 12V7.078c.001-.66.002-1.239-.196-1.76a3 3 0 0 0-.82-1.183c-.418-.368-.96-.57-1.579-.801l-5.492-2.06-.043-.016c-.162-.061-.365-.138-.584-.17Z"
    />
  </svg>
);
SvgShield01.displayName = 'Shield01';
export default SvgShield01;
